import React from 'react';
import UserNotesDashboard from '../../components/contributor/UserNotesDashboard';
import DonationHistoryView from '../../components/contributor/DonationHistoryView';

const DashboardPage: React.FC = () => {
  return (
    <div className="container py-4">
      <div className="row">
        <div className="col-12">
          <UserNotesDashboard />
          
          <hr className="my-4" />
          <DonationHistoryView />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage; 